import React, { useEffect } from 'react';
import {action, autorun, computed, observable, reaction, runInAction} from 'mobx';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { withI18n } from 'spa/Components/Context';

import ArrowRight from '@urbanmassage/component-library/lib/Icons/ArrowRight/ArrowRight';
import Button, { ButtonType } from '@urbanmassage/component-library/lib/Button/Button';
import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';

@inject(({
  store: {
    billing,
  },
}) =>
  ({
    billing,
  }))
@observer
@withI18n
class GiftsFooter extends React.Component {
  static propTypes = {
    billing: PropTypes.shape({
      paymentInfo: PropTypes.shape({
        paymentToken: PropTypes.string,
      }).isRequired,
    }).isRequired,
    currentStep: PropTypes.number.isRequired,
    deliveryOption: PropTypes.string.isRequired,
    deliveryPrice: PropTypes.string.isRequired,
    giftAmountCustomInvalid: PropTypes.bool.isRequired,
    giftAmountInvalid: PropTypes.bool.isRequired,
    giftTreatmentInvalid: PropTypes.bool.isRequired,
    giftUpgradeInvalid: PropTypes.bool.isRequired,
    paymentMethodSelected: PropTypes.string.isRequired,
    showFooter: PropTypes.bool.isRequired,
    totalPrice: PropTypes.string.isRequired,
    voucherPrice: PropTypes.string.isRequired,
  };

  componentDidMount() {
    this.listeners = [
      reaction(
        () => [this.props.giftAmountInvalid, this.props.giftTreatmentInvalid, this.props.giftAmountCustomInvalid, this.props.giftUpgradeInvalid],
        ([giftAmountInvalid, giftTreatmentInvalid, giftAmountCustomInvalid, giftUpgradeInvalid]) => {
          if (this.props.giftAmountInvalid || this.props.giftTreatmentInvalid || this.props.giftAmountCustomInvalid) {
            // setHasGiftError(true);
            this.hasGiftError = true;
          } else {
            // setHasGiftError(false);
            this.hasGiftError = false;
          }
          if (this.props.giftUpgradeInvalid) {
            // setHasUpgradeError(true);
            this.hasUpgradeError = true;
          } else {
            // setHasUpgradeError(false);
            this.hasUpgradeError = false;
          }
        },
        {
          name: 'Initialize error checks',
          fireImmediately: true,
        },
      ),
    ];
  }

  @observable hasGiftError;
  @observable hasUpgradeError;

  render() {
    const {i18n} = this.context;
    const {
      currentStep,
      totalPrice,
    } = this.props;

    if (!this.props.showFooter) {
      return null;
    }

    return (
      <div className="gifts__footer-wrapper">
        <Typography variant={TypeVariants.h3} fontFamily="body" bold className="gifts__footer-total" data-testid="footer-summary-total-to-pay">
          {i18n._x('Total to pay: %(total)s', 'Gifts page', {
            total: totalPrice,
          })}
        </Typography>
        <div className="gifts__footer-button-wrapper">
          {currentStep === 1 && (
            <Button form="voucherFormStep1" postIcon={<ArrowRight />} type={ButtonType.submit} block data-testid="footer-button">
              {i18n._x('Delivery details', 'Gifts page')}
            </Button>
          )}
          {currentStep === 2 && (
            <Button form="voucherFormStep2" postIcon={<ArrowRight />} type={ButtonType.submit} block data-testid="footer-button">
              {i18n._x('Review and pay', 'Gifts page')}
            </Button>
          )}
          {currentStep === 3 && (
            <React.Fragment>
              {(this.props.billing.paymentInfo.paymentToken !== null && this.props.billing.paymentInfo.paymentToken !== '' && this.props.billing.paymentInfo.paymentToken !== undefined) ? (
                <Button form="checkout" postIcon={<ArrowRight />} type={ButtonType.submit} block data-testid="footer-button">{i18n._x('Pay now', 'Gifts page')}</Button>
              ) : (
                <Button disabled form="checkout" postIcon={<ArrowRight />} type={ButtonType.submit} block data-testid="footer-button">{i18n._x('Pay now', 'Gifts page')}</Button>
              )}
            </React.Fragment>
          )}
          {this.hasGiftError && (
            <Typography className="gifts__footer-voucher-amount-error" align="center">{i18n._x('Please select a gift voucher amount', 'Gifts page')}</Typography>
          )}
          {this.hasUpgradeError && (
            <Typography className="gifts__footer-voucher-amount-error" align="center">{i18n._x('Select an upgrade option to continue', 'Gifts page')}</Typography>
          )}
        </div>
      </div>
    );
  }
}

export default GiftsFooter;



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftsFooter.jsx